import React, { useEffect } from "react"
import PropTypes from "prop-types"

import {
  BarSpace,
  SEO,
  HighlightImage,
  TwoColumnIntro,
  MetaStats,
  ImageQuoteGrid,
  StickyNavigator,
} from "gatsby-shared-ui"
import { fireEvent } from "gatsby-shared-ui/utils/helpers"

/**
 * CASES DETAIL page
 */
const CasesDetail = ({ pageContext }) => {
  const {
    title,
    headline,
    client,
    caseYear,
    caseLocation,
    branch,
    caseType,
    highlightImage,
    newsImageGallery,
    shortDescription,
    caseKpis,
    caseQuote,
    prev,
    next,
    media,
  } = pageContext.pageInfo

  useEffect(() => {
    // Set Navbar colors on start
    fireEvent("nav-scheme", caseType === "large" ? "light" : "dark")
    fireEvent("force-logo", "#FF4619")
    fireEvent("middle-component", "CasesGridIcon")
  }, [])

  const isHighlightImage = () => {
    if (media && media[0]) {
      console.log(media)
      return media[0].url && media[0].mimeType
    }

    return false
  }

  return (
    <div className={`pb-10 ${caseType === "large" ? "bg-secondary" : "bg-background"}`}>
      <BarSpace />

      <TwoColumnIntro
        content={{
          twoColumnIntro: {
            title,
            headline,
            client,
            caseYear,
            caseLocation,
            branch,
            caseType,
          },
        }}
      />
      {caseType === "large" && highlightImage && (
        <HighlightImage
          content={{
            highlightImage: [
              {
                url: highlightImage?.[0]?.url,
                mimeType: highlightImage?.[0]?.mimeType,
                embeddedAsset: highlightImage?.[0]?.embeddedAsset,
              },
            ],
          }}
        />
      )}
      {caseType === "large" && <MetaStats content={{ metaStats: { shortDescription, caseKpis, caseType } }} />}
      {caseType === "large" && newsImageGallery && (
        <HighlightImage
          content={{
            highlightImage: [
              {
                url: newsImageGallery?.[0]?.url,
                mimeType: newsImageGallery?.[0]?.mimeType,
                embeddedAsset: newsImageGallery?.[0]?.embeddedAsset,
              },
            ],
          }}
          padding={false}
        />
      )}
      {caseType === "small" && <BarSpace />}
      {newsImageGallery && newsImageGallery.length > 1 && (
        <ImageQuoteGrid
          content={[
            {
              type: "image",
              id: 2,
              imageLink:
                caseType === "small" ? newsImageGallery[0].url : newsImageGallery[1] && newsImageGallery[1].url,
              title: "",
              columns: 2,
              rows:
                (caseType === "small" && newsImageGallery.length > 2) ||
                (caseType === "large" && newsImageGallery.length > 3)
                  ? 2
                  : 1,
            },
            {
              type: caseQuote && caseQuote.length ? "quote" : "image",
              id: 3,
              imageLink:
                caseQuote && caseQuote.length
                  ? null
                  : caseType === "small"
                  ? newsImageGallery[1] && newsImageGallery[1].url
                  : newsImageGallery[2] && newsImageGallery[2].url,
              quote: caseQuote && caseQuote.length && caseQuote[0].quote,
              source: caseQuote && caseQuote.length && caseQuote[0].title,
              role: caseQuote && caseQuote.length && caseQuote[0].role,
              variant: "gray",
              columns: 2,
              rows: 1,
            },
            {
              type: "image",
              id: 4,
              imageLink:
                caseType === "small"
                  ? newsImageGallery[2] && newsImageGallery[2].url
                  : newsImageGallery[3] && newsImageGallery[3].url,
              title: "",
              columns: 2,
              rows: 1,
            },
          ]}
        />
      )}
      {caseType === "small" && <MetaStats content={{ metaStats: { shortDescription, caseKpis, caseType } }} />}
      <div className="mx-auto px-6 md:px-0 max-w-screen-3xl pb-32">
        {isHighlightImage() ? (
          <HighlightImage
            togglePlayback={false}
            content={{
              highlightImage: [
                {
                  url: media[0].url,
                  mimeType: media[0].mimeType,
                  embeddedAsset: media[0].embeddedAsset,
                },
              ],
            }}
            padding={false}
          />
        ) : null}
      </div>
      <StickyNavigator
        title={title}
        prev={prev?.slug}
        next={next?.slug}
        theme={caseType === "large" ? "dark" : "light"}
        parent="cases"
      />
      <BarSpace />
    </div>
  )
}

export const Head = ({ location, pageContext }) => {
  const { caseType, shortDescription, title, highlightImage, client } = pageContext.pageInfo
  return (
    <SEO
      pathname={location.pathname}
      title={`marbet | ${client} ${title}`}
      description={shortDescription}
      locale={pageContext.locale}
      slug={pageContext.slug}
      image={highlightImage[0] ? highlightImage[0].url : null}
    >
      <meta name="theme-color" content={caseType === "small" ? "#FBFBFB" : "#262626"} />
    </SEO>
  )
}

export default CasesDetail

CasesDetail.propTypes = {
  pageContext: PropTypes.object,
}
